<template>
    <div>플래너 정보</div>
</template>

<script>
export default {
    name: 'PlannerInfo',
}
</script>

<style>

</style>